import { API_AGGREGATE_SAVINGS } from '@/constants/urls'
import { axiosApi } from '@/services/http/axiosApi'
import { logger } from '@/services/logger'
import { getCurrency } from '@/helpers/currency'

export const getAggregateSavings = async () => {
  try {
    const { data } = await axiosApi.get(API_AGGREGATE_SAVINGS, {
      params: {
        requestedCurrencyCode: getCurrency()
      }
    })
    return data
  } catch (err: any) {
    logger.error(err)
  }
}
